// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37DHh","colBig":"styles_colBig__1S0vy","colSmall":"styles_colSmall__3J-0U"};